import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import {
  getODataConjunctionFilterFrom,
  getODataDateFilterFrom,
  getODataDisjunctionFilterFrom,
  getODataEQFilterFrom,
  getODataSearchFilterFrom,
} from '@utils/odata';
import {
  API_KEY_EXPIRES_SOON_DELTA,
  API_KEY_SORTING_PARAMS,
  ApiKeySort,
  ApiKeyStatus,
} from '../constants/apiKeys';

const DATE_FMT = 'YYYY-MM-DDTHH:mm:ss[Z]';

const filterByStatus = (status?: ApiKeyStatus): string => {
  const now = dayjs().format(DATE_FMT);

  const { unit, quantity } = API_KEY_EXPIRES_SOON_DELTA;
  const future = dayjs().add(quantity, unit).format(DATE_FMT);

  switch (status || ApiKeyStatus.All) {
    case ApiKeyStatus.All:
      return '';
    case ApiKeyStatus.Active:
      return getODataDisjunctionFilterFrom(
        getODataEQFilterFrom('expires', 'false'),
        getODataDateFilterFrom('expires_at', now),
      );
    case ApiKeyStatus.Expired:
      return getODataConjunctionFilterFrom(
        getODataEQFilterFrom('expires', 'true'),
        getODataDateFilterFrom('expires_at', now, 'lt'),
      );
    case ApiKeyStatus.ExpiresSoon:
      return getODataConjunctionFilterFrom(
        getODataDateFilterFrom('expires_at', now),
        getODataDateFilterFrom('expires_at', future, 'lt'),
      );
  }
};

export const getApiKeyFilterParams = (params?: {
  searchValue?: string;
  sortValue?: ApiKeySort;
  status?: ApiKeyStatus;
}) => {
  const {
    searchValue = '',
    sortValue = ApiKeySort.NEWEST,
    status = ApiKeyStatus.All,
  } = params || {};

  const sortingParams = API_KEY_SORTING_PARAMS[sortValue];
  const searchAndStatus = getODataConjunctionFilterFrom(
    filterByStatus(status),
    isEmpty(searchValue) ? '' : getODataSearchFilterFrom('name', searchValue as string),
  );

  return {
    ...(isEmpty(searchAndStatus) ? {} : { filter: searchAndStatus }),
    ...sortingParams,
  };
};

export const willExpireSoon = (expiresAt: string): boolean => {
  const now = dayjs();
  const expirationTime = dayjs(expiresAt);

  const { unit, quantity } = API_KEY_EXPIRES_SOON_DELTA;
  const aboutToExpireThreshold = now.add(quantity, unit);

  return expirationTime >= now && expirationTime <= aboutToExpireThreshold;
};
